import React, { FunctionComponent } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

type ProfileMenuProps = {
    handleMenuClose:()=>void;
    subProfileMenu: Element | null;
    isMenuOpen: boolean;
  };
export const ProfileMenu: FunctionComponent<ProfileMenuProps> = ({
    handleMenuClose,
    isMenuOpen,
    subProfileMenu
  }) => {
return(
    <div>
    <Menu
      anchorEl={subProfileMenu}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
    </div>
  );
  
}
